<div class="h-screen lg:h-full flex flex-col lg:flex-row" lohiPageTitle="Shift Booking">
  <lohi-shift-map
    class="flex-1"
    [regions]="regions$ | async"
    [selectedRegionId]="(selectedRecommendationGroup$$ | async)?.recommendedShiftId"
    [drivers]="driversWhoCanBookShift$$ | async"
    (regionSelected)="selectRecommendation($event)"
    [selectedDriver]="selectedDriverForm.valueChanges | async"
  ></lohi-shift-map>
  <div class="flex-1 lg:flex-initial lg:w-1/5 p-1 overflow-auto">
    <ng-container *ngIf="selectedRecommendationGroup$$ | async as selectedRec; else selectARegion"
      ><div class="font-bold">
        {{ selectedRec.name }}
        <sup class="text-base font-medium h-2 w-2 text-gray-600 cursor-pointer" (click)="clearSelectedGroup()"
          >&#10005;</sup
        >
      </div>
      <div
        *ngFor="let time of recommendationTimes$$ | async; trackBy: 'startTimestamp' | trackByKey"
        class="p-1 border-b border-gray-400 last:border-0"
      >
        <div class="font-lg">{{ time.startTimestamp | standardDateOnly }}</div>
        <div *ngIf="time.leaderboardModifierText && time.availableShiftCount > 0">
          💎 {{ time.leaderboardModifierText }}
        </div>
        <button
          mat-raised-button
          color="primary"
          [disabled]="time.availableShiftCount === 0"
          (click)="selectTime(time.startTimestamp)"
        >
          {{ (time.startTimestamp | inThePast) ? 'Now' : (time.startTimestamp | standardTime) }} -
          {{ time.endTimestamp | standardTime }}
        </button>
        <div *ngIf="time.availableShiftCount <= 5 && time.availableShiftCount > 0" class="text-red-500">
          Only {{ time.availableShiftCount }} Remaining!
        </div>
      </div></ng-container
    >
    <ng-template #selectARegion>Select a region by clicking the map</ng-template>
  </div>
  <div class="flex-1 lg:flex-initial lg:w-1/4 p-1 border-gray-400 border-l">
    <ng-container *ngIf="selectedRecommendation$$ | async as selectedRec; else selectATime">
      <div class="text-gray-700">
        Please make sure your driver is inside the circle by
        <span class="font-bold text-black"
          >{{ selectedRec.startTimestamp | standardDate }} -
          {{ selectedRec.startTimestamp | addMinutes: selectedRec.startWindowMinutes | standardDate }}</span
        >
        to start their shift
      </div>
      <div class="mt-2 bg-blue-300 p-2" *ngIf="selectedRec.leaderboardModifierText">
        💎 {{ selectedRec.leaderboardModifierText }}
      </div>
      <div class="grid grid-cols-2 gap-2 my-2">
        <div class="text-black">Equipment Type</div>
        <div class="text-gray-700 text-right">
          {{ selectedRec.isBoxShift ? 'Box' : 'Pneumatic' }}
        </div>
        <div class="text-black">Estimated Earnings</div>
        <div class="text-gray-700 text-right">
          {{ selectedRec.estimatedEarningsCentsLower | currencyInPennies }} -
          {{ selectedRec.estimatedEarningsCentsUpper | currencyInPennies }}
        </div>
        <div class="text-black">Estimated Turns</div>
        <div class="text-gray-700 text-right">
          {{ selectedRec.estimatedTurnsLower }} - {{ selectedRec.estimatedTurnsUpper }}
        </div>
      </div>
      <div>
        <div class="font-bold">HSE Requirements</div>
        <div>{{ selectedRec.hseRequirements }}</div>
      </div>

      <div class="mt-2">
        <div *ngIf="(driversWhoCanBookShift$$ | async)?.length; else noDriversCanBook" class="flex flex-col">
          <mat-form-field class="w-full">
            <mat-label>Select Driver</mat-label>
            <mat-select [formControl]="selectedDriverForm">
              <mat-option>
                <ngx-mat-select-search
                  placeholderLabel="Find Driver"
                  noEntriesFoundLabel="No Matching Drivers Found"
                  [formControl]="driverSearch"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let driver of filteredDriversWhoCanBook$ | async; trackBy: 'id' | trackByKey"
                [value]="driver"
              >
                {{ driver.driverName }} {{ driver.phoneNumber | phone }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="selectedDriverForm.value" class="py-2">
            <div class="font-bold">HSE Requirements</div>
            <div>
              I confirm that <span class="font-bold">{{ selectedDriverForm.value.driverName }}</span> is qualified to
              meet this job's requirements and have reviewed the job and HSE details
            </div>
            <mat-checkbox [formControl]="hseConfirmed">Meets Requirements</mat-checkbox>
          </div>
          <button
            mat-raised-button
            color="primary"
            [disabled]="!selectedDriverForm.value || !hseConfirmed.value || (bookingShift$$ | async)"
            (click)="bookShiftForDriver()"
          >
            Book Shift
          </button>
        </div>
        <ng-template #noDriversCanBook>
          <div class="text-gray-700">You do not have any drivers who can book this shift</div>
        </ng-template>
      </div>
    </ng-container>
    <ng-template #selectATime>Select a time</ng-template>
  </div>
</div>
